<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li>
              <router-link to="/accounting_rules" class="">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
            </li>
            <li>
              <h3>{{ $t("accounting.label.createrule") }}</h3>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.accountingrulename')"
              >
                <vs-input
                  :label="$t('accounting.label.accountingrulename')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="accountingRuleName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("accounting.label.entityname")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('accounting.label.entityname')"
                >
                  <v-select
                    label="name"
                    v-model="accountType"
                    :options="TemplateData.allowedOffices"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('accounting.label.description')"
                class="w-full mb-2 font-semibold"
                v-model="description"
              />
            </div>
          </div>
          <div class="w-full mt-5">
            <ul class="heading-ul mb-3">
              <li>
                <h3>
                  {{ $t("accounting.label.affectedglentries")
                  }}<span class="required"> *</span>
                </h3>
              </li>
            </ul>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="flex-container">
                <h4 class="section-title">
                  {{ $t("accounting.label.debitaccountdetails") }}
                </h4>
                <div class="radio-group">
                  <div class="radio-option">
                    <vs-radio
                      v-model="paymentTypeDebit"
                      vs-value="fixed_amount"
                      class="mr-4"
                      vs-name="debitRadios"
                    >
                      {{ $t("accounting.label.FixedAmount") }}
                    </vs-radio>
                  </div>
                  <div class="radio-option">
                    <vs-radio
                      v-model="paymentTypeDebit"
                      vs-value="accounts"
                      class="mr-4"
                      vs-name="debitRadios"
                    >
                      {{ $t("accounting.label.Accounts") }}
                    </vs-radio>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="flex-container">
                <h4 class="section-title">
                  {{ $t("accounting.label.creditaccountdetails") }}
                </h4>
                <div class="radio-group">
                  <div class="radio-option">
                    <vs-radio
                      v-model="paymentTypeCredit"
                      vs-value="fixed_amount"
                      class="mr-4"
                      vs-name="creditRadios"
                    >
                      {{ $t("accounting.label.FixedAmount") }}
                    </vs-radio>
                  </div>
                  <div class="radio-option">
                    <vs-radio
                      v-model="paymentTypeCredit"
                      vs-value="accounts"
                      class="mr-4"
                      vs-name="creditRadios"
                    >
                      {{ $t("accounting.label.Accounts") }}
                    </vs-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div
              v-if="paymentTypeDebit == 'fixed_amount'"
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.debitaccountdetails')"
              >
                <v-select
                  label="name"
                  v-model="debitFixedAmount"
                  :options="TemplateData.allowedAccounts"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              v-if="paymentTypeDebit == 'accounts'"
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.debitaccountdetails')"
              >
                <v-select
                  label="name"
                  multiple
                  v-model="selectedDebitTags"
                  :options="TemplateData.allowedDebitTagOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              v-if="paymentTypeCredit == 'fixed_amount'"
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.creditaccountdetails')"
              >
                <v-select
                  label="name"
                  v-model="creditFixedAmount"
                  :options="TemplateData.allowedAccounts"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              v-if="paymentTypeCredit == 'accounts'"
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.creditaccountdetails')"
              >
                <v-select
                  label="name"
                  multiple
                  v-model="selectedCreditTags"
                  :options="TemplateData.allowedCreditTagOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                v-if="paymentTypeDebit == 'accounts'"
                class="mt-5 mb-5 font-semibold"
                v-model="multipleDebitEntries"
                >{{
                  $t("accounting.label.allowmultipledebitentries")
                }}</vs-checkbox
              >
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                v-if="paymentTypeCredit == 'accounts'"
                class="mt-5 mb-5 font-semibold"
                v-model="multipleCreditEntries"
                >{{
                  $t("accounting.label.allowmultiplecreditentries")
                }}</vs-checkbox
              >
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="haldleSubmit"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      paymentTypeDebit: "fixed_amount",
      paymentTypeCredit: "fixed_amount",
      accountType: "",
      warningPopup: false,
      multipleCreditEntries: false,
      multipleDebitEntries: false,
      warningText: "",
      errorMessage: "",
      accountingRuleName: "",
      description: "",
      debitFixedAmount: "",
      creditFixedAmount: "",
      selectedDebitTags: "",
      selectedCreditTags: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      TemplateData: (state) => state.accounting.accountingRulesTemplate,
    }),
  },
  methods: {
    async getTemplateData() {
      try {
        await this.$store.dispatch(
          "accounting/getAccountingRulesTemplateAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async haldleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        name: this.accountingRuleName,
        officeId: this.accountType,
        description: this.description,
      };
      if (this.debitFixedAmount) {
        payload.accountToDebitId = this.debitFixedAmount;
      }
      if (this.creditFixedAmount) {
        payload.accountToCreditId = this.creditFixedAmount;
      }
      if (this.selectedDebitTags) {
        payload.debitTags = this.selectedDebitTags;
      }
      if (this.selectedCreditTags) {
        payload.creditTags = this.selectedCreditTags;
      }
      if (this.paymentTypeCredit == "accounts") {
        payload.allowMultipleCreditEntries = this.multipleCreditEntries;
      }
      if (this.paymentTypeDebit == "accounts") {
        payload.allowMultipleDebitEntries = this.multipleDebitEntries;
      }
      try {
        await this.$store.dispatch(
          "accounting/createAccountingRuleAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Rule Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push("/accounting_rules");
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.paymentTypeDebit = "fixed_amount";
      this.paymentTypeCredit = "fixed_amount";
      this.accountType = "";
      this.warningPopup = false;
      this.multipleCreditEntries = false;
      this.multipleDebitEntries = false;
      this.warningText = "";
      this.errorMessage = "";
      this.accountingRuleName = "";
      this.description = "";
      this.debitFixedAmount = "";
      this.creditFixedAmount = "";
      this.selectedDebitTags = "";
      this.selectedCreditTags = "";
    },
  },
  watch: {
    paymentTypeDebit(newValue) {
      if (newValue === "accounts") {
        this.debitFixedAmount = null;
      }
      if (newValue === "fixed_amount") {
        this.selectedDebitTags = null;
      }
    },
    paymentTypeCredit(newValue) {
      if (newValue === "accounts") {
        this.creditFixedAmount = null;
      }
      if (newValue === "fixed_amount") {
        this.selectedCreditTags = null;
      }
    },
  },
  mounted() {
    this.getTemplateData();
  },
};
</script>
<style>
.section-title {
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  margin-right: 1rem;
}
.flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.radio-group {
  display: flex;
  align-items: center;
}

.radio-option {
  display: flex;
  align-items: center;
}
</style>
